
import React, { useState } from 'react';
import axios from 'axios';
import { MessageCircle, X } from 'lucide-react';
import './ChatBot.css'
const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const toggleChat = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const newMessages = [...messages, { text: input, isUser: true }];
    setMessages(newMessages);
    setIsLoading(true);

    try {
      const response = await axios.post('/api/react/chat', {
        message: input
      });

      setMessages((prevMessages) => [
        ...prevMessages,
        { text: response.data.response, isUser: false, confidence: response.data.confidence }
      ]);
    } catch (error) {
      console.error('Error:', error);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: 'Sorry, I encountered an error. Please try again.', isUser: false }
      ]);
    }

    setInput('');
    setIsLoading(false);
  };

  return (
    <div className="chat-widget-container">
      {!isOpen && (
        <button className="chat-widget-toggle" onClick={toggleChat}>
          <MessageCircle size={24} />
        </button>
      )}

      {isOpen && (
        <div className="chat-widget">
          <div className="chat-widget-header">
            <h2 className="chat-widget-title">Chat Assistant</h2>
            <button className="chat-widget-close" onClick={toggleChat}>
              <X size={24} />
            </button>
          </div>

          <div className="chat-widget-messages">
            {messages.map((message, index) => (
              <div key={index} className={`chat-message ${message.isUser ? 'chat-message-user' : 'chat-message-bot'}`}>
                <div className="chat-message-text">{message.text}</div>
                
              </div>
            ))}
          </div>

          <form onSubmit={handleSubmit} className="chat-widget-input-form">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type a message..."
              className="chat-widget-input"
              disabled={isLoading}
            />
            <button type="submit" className={`chat-widget-send-button ${isLoading ? 'chat-widget-send-button-disabled' : ''}`} disabled={isLoading}>
              Send
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ChatBot;